import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-gradient-to-br from-cream to-white py-12 md:py-20 px-4" data-id="element-66">
      <div className="max-w-7xl mx-auto" data-id="element-67">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-68">
          {/* Left Column - Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-69">
            <h1 className="font-playfair font-bold text-4xl md:text-5xl lg:text-6xl text-brown leading-tight mb-6" data-id="element-70">
              Presentamos La Guía Más Completa Para Crear Jabones Artesanales
              Profesionales
            </h1>
            <p className="font-inter text-xl md:text-2xl text-brown/80 mb-8 leading-relaxed" data-id="element-71">
              y Montar Tu Propio Negocio Rentable Desde Casa en Menos de 7 Días
            </p>

            {/* Trust Badges */}
            <div className="flex flex-wrap items-center gap-6 mb-8" data-id="element-72">
              <div className="flex items-center gap-2" data-id="element-73">
                <div className="flex" data-id="element-74">
                  {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 fill-gold text-gold" data-id="element-75" />)}
                </div>
                <span className="font-inter text-sm text-brown/70" data-id="element-76">
                  2,500+ Alumnas
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-77">
                <ShieldCheckIcon className="w-6 h-6 text-sage" data-id="element-78" />
                <span className="font-inter text-sm text-brown/70" data-id="element-79">
                  Garantía 7 Días
                </span>
              </div>
            </div>

            {/* Video Placeholder */}
            <div className="bg-gradient-to-br from-terracotta/20 to-sage/20 rounded-lg p-8 text-center border-2 border-terracotta/30" data-id="element-80">
              <p className="font-inter text-sm text-brown/60 mb-4" data-id="element-81">
                (Asegúrate de tener el sonido activado. Espera hasta 10 segundos
                a que cargue el video)
              </p>
              <div className="aspect-video bg-brown/10 rounded-lg flex items-center justify-center" data-id="element-82">
                <p className="font-playfair text-2xl text-brown/40" data-id="element-83">
                  ▶ Video Presentación
                </p>
              </div>
              <p className="font-montserrat font-bold text-lg text-terracotta mt-6" data-id="element-84">
                ▶ Mira Este Video Hasta El Final y Obtén Acceso Inmediato Al
                Libro + 9 Bonos GRATIS
              </p>
            </div>
          </motion.div>

          {/* Right Column - Hero Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="relative" data-id="element-85">
            <div className="aspect-square bg-gradient-to-br from-terracotta via-sage to-gold rounded-2xl shadow-2xl flex items-center justify-center" data-id="element-86">
              <div className="text-center text-white p-8" data-id="element-87">
                <p className="font-playfair text-3xl md:text-4xl font-bold mb-4" data-id="element-88">
                  Secretos de los Jabones
                </p>
                <p className="font-inter text-lg" data-id="element-89">+50 Recetas Profesionales</p>
              </div>
            </div>
            {/* Decorative Badge */}
            <div className="absolute -top-4 -right-4 bg-urgency text-white rounded-full w-24 h-24 flex items-center justify-center shadow-xl transform rotate-12" data-id="element-90">
              <div className="text-center" data-id="element-91">
                <p className="font-montserrat font-bold text-2xl" data-id="element-92">60%</p>
                <p className="font-inter text-xs" data-id="element-93">OFF</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}